import { render, staticRenderFns } from "./ResultsKeywords.vue?vue&type=template&id=b274ad1a&"
import script from "./ResultsKeywords.vue?vue&type=script&lang=js&"
export * from "./ResultsKeywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports